$(function() {
    if($('.infographic-section').length > 0){

        var animateHTML = function () {
            var elems,
                windowHeight,
                windowWidth
            var init = function () {
                elems = document.getElementsByClassName('hidden')
                windowHeight = window.innerHeight
                windowWidth = window.innerWidth
                _addEventHandlers()
            }
            var _addEventHandlers = function () {
                window.addEventListener('scroll', _checkPosition)
                window.addEventListener('resize', init)
            }
            var _checkPosition = function () {
                for (var i = 0; i < elems.length; i++) {
                    var posFromTop = elems[i].getBoundingClientRect().top,
                        infographic = function() {
                            elems[i].className = elems[i].className.replace('hidden', 'show-element')
                            var tl = new TimelineLite();
                            tl.to(".tile-wrapper .tile.tile1", .5, { opacity:"1", x:"+=0", y:"-=100", rotation: "45", ease: Back.easeOut.config(2.7)}, 0.15);
                            tl.to(".tile-wrapper .tile.tile2", .5, { opacity:"1", x:"+=100", y:"+=0", rotation: "45", ease: Back.easeOut.config(2.7)}, 0.15);
                            tl.to(".tile-wrapper .tile.tile3", .5, { opacity:"1", x:"-=0", y:"+=100", rotation: "45", ease: Back.easeOut.config(2.7)}, 0.15);
                            tl.to(".tile-wrapper .tile.tile4", .5, { opacity:"1", x:"-=100", y:"+=0", rotation: "45", ease: Back.easeOut.config(2.7)}, 0.15);
                            tl.to(".tile-content", 1, { opacity:"1",delay:1}, 0.15);
                            tl.to(".svg-rev-mask", .6, { x:"+=500", y:"+=0", delay:0.5}, 0.15);
                        }


                    if (windowWidth > 641) {
                        if (posFromTop - windowHeight <= -425) {
                            infographic()
                        }
                    } else {
                        if (posFromTop - windowHeight <= 300) {
                            infographic()
                        }
                    }
                }
            }
            return {
                init: init
            }
        }
        animateHTML().init()
    }

})